import { h } from 'preact'
import logoJo2024 from './logo-paris-2024-orange.png'

export const Jo2024 = () => {
   return (
      <div class="jo-2024" data-testid="bande-jo-2024">
         <a href="https://www.orange.com/fr/deployons-Paris-2024-pour-tous">
            <img src={logoJo2024} alt="Paris 2024 - Orange Partenaire Premium" loading="lazy" />
         </a>
      </div>
   )
}
